import { getMe } from "@/lib/api";
import { queryKeys } from "@/lib/query-keys";
import { useQuery } from "@tanstack/react-query";

export function useMe() {
	return useQuery({
		queryKey: queryKeys.me,
		queryFn: getMe,
	});
}
